<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
        <div class="drawer-box" style="width: 100%;height: 100%;padding-bottom: 36px;">
            <section>
                <h4><b>基础信息</b></h4>
                <p style="padding:0 2em;">
                    <span style="margin:0 2em;">原料名称：{{ detailInfo.name }}</span>
                    <span style="margin:0 2em;">原料代码：{{ detailInfo.code }}</span>
                    <span style="margin:0 2em;">库存组织编码：{{ detailInfo.ebsMaterialCode }} </span>
                </p>
            </section>
            <section class="justifyBox" style="margin: 12px 0;">
                <h4><b>进货质量台账</b> <span style="color: #FF7E11; font-size: 14px;">* 来源于近红外的数据</span></h4>
            </section>

            <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" row-key="id"
                :row-selection="{
                    selectedRowKeys,
                    onChange: onSelectChange,
                    getCheckboxProps,
                }" bordered :pagination="pagination" :scroll="{ x: 1790, y: 600 }">

            </a-table>
        </div>

        <footer>
            <a-button icon="left" @click="onClose">返回</a-button>
            <a-button type="primary" :disabled="selectedRowKeys.length==0" :loading="confirmLoading"
                @click="onConfirm">确定</a-button>
        </footer>

        <template #title>
            <b>切换批次</b>
        </template>
    </a-drawer>
</template>

<script>

const tableColumns = [
    {
        title: "批次",
        align: 'center',
        dataIndex: "batchNo",
        width: 120,
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "生产厂商",
        align: 'center',
        dataIndex: "manufacturer",
        width: 180,
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "产地",
        align: 'center',
        dataIndex: "producePlace",
        width: 150,
        ellipsis: true
    },
    {
        title: "供货商",
        align: 'center',
        dataIndex: "supplyCompany",
        width: 200,
        ellipsis: true
    },
    {
        title: "入库数量(KG)",
        align: 'center',
        dataIndex: "storeNum",
        width: 120,
        ellipsis: true
    },
    {
        title: "库存量(KG)",
        align: 'center',
        dataIndex: "batchStorageNum",
        width: 120,
        ellipsis: true
    }
];

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        detailInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            batchNo: '',
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },
            drawerWidth: 1200,
            tableLoading: false,
            tableColumns: [],
            tableData: [],
            pagination: {
                total: 0,
                pageSize: 20,
                current: 1,
                showSizeChanger: true,
                showTotal: (total) => `共${total}条记录`,
                onChange: (current, pageSize) => {
                    this.pagination.current = current;
                    this.pagination.pageSize = pageSize;
                    this.getData();
                }, //选择页数
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.pageSize = pageSize;
                    this.pagination.current = 1;
                    this.getData();
                }, //每页多少条
            },

            selectedRowKeys: [],
            confirmLoading: false
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.tableColumns = [].concat(tableColumns);
                this.selectedRowKeys = [];
                this.getData();
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1200) {
            this.drawerWidth = _width;
        }
    },
    methods: {
        getCheckboxProps(record) {
            return ({
                props: {
                    disabled: record.disabled
                },
            });
        },
        onSelectChange(selectedId) {
            this.selectedRowKeys = selectedId;
        },
        // 处理数据同时动态生成表格
        processData(data) {
            const _nutritionColumns = data[0].datasyncFeedResultItemVOList.map(dto => {
                const nutritionName = dto.nutritionName;
                return {
                    title: `${dto.nutritionName}(${dto.testUnit})`,
                    align: 'center',
                    dataIndex: dto.nutritionName + "_checkValue",
                    width: 120,
                    ellipsis: true,
                    customRender: (text, record) => {
                        const isNir = record[`${nutritionName}_isNir`];
                        return {
                            children: text,
                            attrs: {
                                style: isNir === '1' ? 'color: #FF7E11; font-weight: bold;' : ''
                            }
                        };
                    }
                };
            });

            const _tempData = [];
            data.forEach(item => {
                const _temp = {};
                _temp.batchNo = item.batchNo;
                _temp.manufacturer = item.manufacturer;
                _temp.producePlace = item.producePlace;
                _temp.supplyCompany = item.supplyCompany;
                _temp.batchStorageNum = item.batchStorageNum;
                _temp.id = item.id;
                _temp.supplier = item.supplier;
                _temp.storeNum = item.storeNum;
                item.datasyncFeedResultItemVOList.forEach(dto => {
                    _temp[`${dto.nutritionName}_checkValue`] = dto.checkValue;
                    _temp[`${dto.nutritionName}_isNir`] = dto.isNir;
                });

                _tempData.push(_temp);
            });

            if (this.tableColumns.length == 6) {
                this.tableColumns = this.tableColumns.concat(_nutritionColumns);
            }
            this.tableData = [].concat(_tempData);
        },
        // 获取表格
        getData() {
            if (this.tableLoading)
                return;
            this.tableData = [];
            const { current = 1, pageSize = 20 } = this.pagination
            const data = {
                materialCode: this.detailInfo.code,
                stockOrgCode: this.detailInfo.ebsMaterialCode,
                query: {
                    current: current,
                    size: pageSize
                }
            };
            this.tableLoading = true;
            this.$post('/nhf-app/datasyncfeedresultitem/pageDatasyncFeedResultItem', data).then(res => {
                if (res.success) {
                    if (res.data.records.length > 0) {
                        this.pagination.current = res.data.current
                        this.pagination.total = res.data.total;
                        this.processData(res.data.records);
                    }
                }
                this.tableLoading = false;
            });
        },
        onConfirm() {
            this.confirmLoading = true;
            const data = {
                factoryId: window.localStorage.getItem("factoryId"),
                materialCode: this.detailInfo.code,
                orgCode: this.detailInfo.ebsMaterialCode,
                rawId: this.detailInfo.id,
                batchIdList: this.selectedRowKeys
            };
            this.$post('/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawWithLIMSChangeBatch', data).then(res => {
                if (res.success) {
                    this.$emit('confirm', { tableData: res.data, batchIdList: this.selectedRowKeys });
                }
                this.confirmLoading = false;
            });

        },
        onClose() {
            this.$emit('close');
        },
    }
};
</script>


<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

::v-deep .ant-checkbox-wrapper-disabled {
    display: none;
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }

    >div {
        display: flex;
        align-items: center;
    }
}
</style>
